/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum IndexType {
	Add = 'Add',
	Update = 'Update',
	Delete = 'Delete',
	Batch = 'Batch',
	Checkpoint = 'Checkpoint',
	Lock = 'Lock',
	Flush = 'Flush',
}
